import React, { Component } from "react";
import Aux from "../../../hoc/Auxilliary";
import AdminDashboard from "./Dashboad";
import AdminCountries from "./Countries/Countries";
import AdminModules from "./Modules/Modules";
import AdminUsers from "./Users/Users";
import AdminJobRoleGrups from "./JobRoleGroups/JobRoleGroups";
import AdminWorkflowVideoCategories from "./WorkflowVideoCategories/WorkflowVideoCategories";
import AdminLearningCategories from "./LearningCategories/LearningCategories";
import AdminLearningVideoCategories from "./LearningVideoCategories/LearningVideoCategories";
import AdminLearningVideos from "./LearningVideos/LearningVideos";
import AdminWorkflowVideos from "./WorkflowVideos/WorkflowVideos";
import AdminAssignment from "./Assignment/Assignment";
import AdminTranslation from "./Translation/Translation";
import AdminStates from "./States/States";
import AdminJobRoles from "./JobRoles/JobRoles";
import AdminConstant from "./Constant/Constant";
import AdminIntegration from "./Integration/Integration";
import AdminCategories from "./Categories/Categories";

class AdminMainContent extends Component {
  render() {
    return (
      <Aux>
        {this.props.page === "dashboard" && <AdminDashboard {...this.props} />}
        {this.props.page === "modules" && <AdminModules {...this.props} />}
        {this.props.page === "countries" && <AdminCountries {...this.props} />}
        {this.props.page === "categories" && (
          <AdminCategories {...this.props} />
        )}
        {this.props.page === "states" && <AdminStates {...this.props} />}
        {this.props.page === "users" && <AdminUsers {...this.props} />}
        {this.props.page === "jobrolegroups" && (
          <AdminJobRoleGrups {...this.props} />
        )}
        {this.props.page === "jobroles" && <AdminJobRoles {...this.props} />}
        {this.props.page === "workflowvideocategories" && (
          <AdminWorkflowVideoCategories {...this.props} />
        )}
        {this.props.page === "learningcategories" && (
          <AdminLearningCategories {...this.props} />
        )}
        {this.props.page === "learningvideocategories" && (
          <AdminLearningVideoCategories {...this.props} />
        )}
        {this.props.page === "learningvideos" && (
          <AdminLearningVideos {...this.props} />
        )}
        {this.props.page === "workflowvideos" && (
          <AdminWorkflowVideos {...this.props} />
        )}
        {this.props.page === "assignment" && (
          <AdminAssignment {...this.props} />
        )}
        {this.props.page === "translation" && (
          <AdminTranslation {...this.props} />
        )}
        {this.props.page === "constants" && <AdminConstant {...this.props} />}
        {this.props.page === "integration" && (
          <AdminIntegration {...this.props} />
        )}
      </Aux>
    );
  }
}

export default AdminMainContent;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/AdminMainContent.js